/* eslint-disable import/prefer-default-export */
export const PATCH_PASSWORD = 'PATCH_PASSWORD';
export const SAVING_PASSWORD = 'SAVING_PASSWORD';
export const DISMISS_MESSAGES = 'DISMISS_MESSAGES';
export const SET_SAVED = 'SET_SAVED';
export const SENDING_MAIL = 'SENDING_MAIL';
export const SEND_MAIL = 'SEND_MAIL';
export const GETTING_TOKEN_STATUS = 'GETTING_TOKEN_STATUS';
export const GET_TOKEN_STATUS = 'GET_TOKEN_STATUS';

export const getActionCreators = () => {
  const actionCreators = {
    clear: () => (dispatch) => {
      dispatch({
        type: SET_SAVED,
      });
    },
    dismissMessages: () => (dispatch) => {
      dispatch({
        type: DISMISS_MESSAGES,
      });
    },
    patchPassword: (data, callback, lang = 'da') => async (dispatch) => {
      dispatch({
        type: SAVING_PASSWORD,
      });

      callback(data, (ok, status, json) => {
        const result = {};
        if (ok) {
          result.password = true;
        } else {
          result.error = json;
          result.error.lang = lang;
        }
        result.status = status;
        dispatch({
          type: PATCH_PASSWORD,
          result,
        });
      });
    },
    patchPasswordAnonymous: (endpoint, type, userToken, data, callback, lang = 'da') => async (dispatch) => {
      dispatch({
        type: SAVING_PASSWORD,
      });

      callback(endpoint, type, userToken, data, (ok, status, json, actionType) => {
        const result = {};
        if (ok) {
          result.password = json;
        } else {
          result.error = json;
          result.error.lang = lang;
        }
        result.status = status;
        dispatch({
          type: actionType,
          result,
        });
      });
    },
    sendMail: (data, callback, lang = 'da') => async (dispatch) => {
      dispatch({
        type: SENDING_MAIL,
      });

      callback(data, (ok, status, json) => {
        const result = {};
        if (ok) {
          result.password = true;
        } else {
          result.error = json;
          result.error.lang = lang;
        }
        result.status = status;
        dispatch({
          type: SEND_MAIL,
          result,
        });
      });
    },
    checkUserTokenIsValid: (userToken, callback) => async (dispatch) => {
      dispatch({
        type: GETTING_TOKEN_STATUS,
      });

      callback(userToken, (ok, status) => {
        const result = {};
        result.token = ok;
        result.status = status;
        dispatch({
          type: GET_TOKEN_STATUS,
          result,
        });
      });
    },
  };

  return actionCreators;
};
